import { _ADMINS } from '../../constants/links';
import { APICore } from './apiCore';

const api = new APICore();

// account
function login(params: { email: string; password: string }) {
    const baseUrl =  'back/admin/login';
    return api.create(`${baseUrl}`, params);
}

function logout() {
    const baseUrl = '/logout/';
    return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string; password: string }) {
    const baseUrl = '/register/';
    return api.create(`${baseUrl}`, params);
}

function forgotPassword(email: string) {
    const baseUrl = _ADMINS + 'forgot-password/' + email;
    return api.get(`${baseUrl}`, {});
}

export { login, logout, signup, forgotPassword };
